module.exports = __webpack_public_path__ + "static/media/insta-inverted-logo.fb4fc554.svg";